import { BibliographicResource } from '®shared/bibliographic-resource';

export enum FieldContextMenuOption {
  REMOVE_FIELD = 'removeField',
  MOVE_FIELD_TO_OTHER_PART = 'moveFieldToOtherPart',
  MOVE_INDEX_UP = 'moveIndexUp',
  MOVE_INDEX_DOWN = 'moveIndexDown',
  SWAP_AUTHOR_PARTS = 'swapAuthorParts',
  CHANGE_AUTHOR_TO_EDITOR = 'changeAuthorToEditor',
  CHANGE_EDITOR_TO_AUTHOR = 'changeEditorToAuthor',
}

export enum FieldContentMenuFormPart {
  PRIMARY = 'primary',
  PART_OF = 'part_of',
}

export type FieldContextMenuEnabledOptions = FieldContextMenuOption[];

export interface FieldContextMenuFieldInfo {
  fieldName: keyof BibliographicResource;
  index?: number;
}

export interface FieldContextMenuOperation extends FieldContextMenuFieldInfo {
  operation: FieldContextMenuOption;
  formPart?: FieldContentMenuFormPart;
}
